import type { Instance } from '../api/client'

export const BUSY_STATUSES: Instance['status'][] = [
  'provisioning',
  'initializing',
  'restoring',
  'replacing_filestore',
  'updating',
  'deleting',
  'restarting',
]

export const isBusy = (status?: Instance['status']) => {
  if (!status) return false
  return BUSY_STATUSES.includes(status)
}

export const isStable = (status?: Instance['status']) => {
  return status === 'running' || status === 'stopped' || status === 'error'
}
